import { t } from "i18next"
import React from "react"
import { Button, Form, InputGroup, ListGroup, Spinner } from "react-bootstrap"
import { X } from "react-bootstrap-icons"
import { PaginationItem } from "../../../../components"
import { ListGroupItem } from "./ListGroupItem"

type Props = {
  title: string
  listType: "select" | "deselect"
  searchText: string
  loadingItemIds: string[]
  trackerList: {
    name: string
    serialnumber: string
    fleet?: {
      name: string
      uuid: string
    }
  }[]
  activePage: number
  totalPages: number
  trackerCount: number
  listLoading: boolean
  onSearchChange: (text: string) => void
  onPageChange: (page: number) => void
  onItemPress: (
    serialnumber: string,
    trackerCurrentlyInFleet: { uuid: string; name: string },
  ) => void
}

export const TrackerSelectList: React.FC<Props> = ({
  title,
  listType,
  searchText,
  loadingItemIds,
  trackerList,
  activePage,
  totalPages,
  trackerCount,
  listLoading,
  onSearchChange,
  onPageChange,
  onItemPress,
}) => {
  return (
    <div>
      <h5>
        {title} ({trackerCount})
      </h5>
      <InputGroup className="mb-2">
        <Form.Control
          type="search"
          id="tracker-search"
          autoComplete="off"
          placeholder={t("sidebar.search_placeholder")}
          value={searchText}
          onChange={(e) => {
            onSearchChange(e.target.value)
          }}
        />
        {searchText && (
          <Button
            type="button"
            aria-label="Clear search"
            variant="outline-secondary"
            className="d-flex align-items-center"
            onClick={() => {
              onSearchChange("")
            }}
          >
            <X size={16} />
          </Button>
        )}
      </InputGroup>
      <div className="position-relative">
        {listLoading && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center rounded"
            style={{
              zIndex: 1000,
              backgroundColor: "rgba(0, 0, 0, 0.3)",
            }}
          >
            <Spinner size="sm" />
          </div>
        )}
        <ListGroup className="mb-2 " style={{ minHeight: "42px" }}>
          {trackerList?.map((tracker, index) => (
            <ListGroupItem
              key={tracker.serialnumber}
              itemId={index}
              loading={loadingItemIds.includes(tracker.serialnumber)}
              text={`${tracker.serialnumber} - ${tracker.name}`}
              badgeText={listType === "select" && tracker?.fleet ? tracker.fleet.name : undefined}
              iconType={listType === "select" ? "add" : "remove"}
              onPress={() =>
                onItemPress(tracker.serialnumber, {
                  uuid: tracker.fleet?.uuid,
                  name: tracker.fleet?.name,
                })
              }
            />
          ))}
          {trackerList?.length === 0 && !listLoading && (
            <ListGroup.Item className="text-center text-muted">
              <>{t("settings.partner.no_trackers")}</>
            </ListGroup.Item>
          )}
        </ListGroup>
      </div>
      <PaginationItem activePage={activePage} pagesCount={totalPages} onChangePage={onPageChange} />
    </div>
  )
}
